import { c as _c } from "react/compiler-runtime";
import { useDndContext, useDraggable, useDroppable } from '@dnd-kit/core';
import { type ReactElement, useCallback, useMemo } from 'react';
import type { ChartDataRow } from '../../../types';
import { ROW_SELECTION_COLUMN_ID } from '../constants';
import type { HeaderLabelDataWithElement, TableHeadCellProps } from '../types';
import { getHeaderContext, getHeaderLabelData } from '../utils';
import { createColumnDragId, createColumnDropId } from '../utils/dnd';
import TableHeadCell from './TableHeadCell';
const TableHeadCellDnD = props => {
  const $ = _c(31);
  const {
    header,
    allowColumnPinning
  } = props;
  const {
    isPlaceholder,
    column
  } = header;
  let t0;
  if ($[0] !== props) {
    t0 = getHeaderContext(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const context = t0;
  const dndDisabled = isPlaceholder || column.id === ROW_SELECTION_COLUMN_ID;
  const {
    active
  } = useDndContext();
  const activeDragPinned = active?.data.current == null ? null : (active.data.current as HeaderLabelDataWithElement).pinned;
  let t1;
  if ($[2] !== context) {
    t1 = getHeaderLabelData(context);
    $[2] = context;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const draggableData = t1;
  let t2;
  if ($[4] !== column.id) {
    t2 = createColumnDropId(column.id);
    $[4] = column.id;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = dndDisabled || !allowColumnPinning && draggableData.pinned !== activeDragPinned;
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      id: t2,
      disabled: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    setNodeRef: setDropRef,
    isOver
  } = useDroppable(t4);
  let t5;
  if ($[9] !== column.id) {
    t5 = createColumnDragId(column.id);
    $[9] = column.id;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dndDisabled || $[12] !== draggableData || $[13] !== t5) {
    t6 = {
      id: t5,
      disabled: dndDisabled,
      data: draggableData
    };
    $[11] = dndDisabled;
    $[12] = draggableData;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const {
    attributes,
    listeners,
    setNodeRef: setDragNodeRef,
    setActivatorNodeRef,
    isDragging
  } = useDraggable(t6);
  let t7;
  if ($[15] !== dndDisabled || $[16] !== setDragNodeRef || $[17] !== setDropRef) {
    t7 = node => {
      setDropRef(node);
      if (!dndDisabled) {
        setDragNodeRef(node);
      }
    };
    $[15] = dndDisabled;
    $[16] = setDragNodeRef;
    $[17] = setDropRef;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const setCellRef = t7;
  const t8 = dndDisabled ? undefined : setCellRef;
  const t9 = dndDisabled ? false : isOver;
  const t10 = dndDisabled ? false : isDragging;
  let t11;
  if ($[19] !== attributes || $[20] !== dndDisabled || $[21] !== listeners || $[22] !== setActivatorNodeRef) {
    t11 = dndDisabled ? undefined : {
      setActivatorNodeRef,
      listeners,
      attributes
    };
    $[19] = attributes;
    $[20] = dndDisabled;
    $[21] = listeners;
    $[22] = setActivatorNodeRef;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== context || $[25] !== props || $[26] !== t10 || $[27] !== t11 || $[28] !== t8 || $[29] !== t9) {
    t12 = <TableHeadCell {...props} context={context} columnDnDCellRef={t8} columnDnDIsDropTarget={t9} columnDnDIsDragging={t10} columnDnDDragHandle={t11} />;
    $[24] = context;
    $[25] = props;
    $[26] = t10;
    $[27] = t11;
    $[28] = t8;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
export default TableHeadCellDnD;